import { inject, provide } from 'vue';

export interface ApiConfig {
  apiCreate: string;
  apiUpdate: string;
  apiDelete: string;
  apiList: string;
  apiListArchived?: string;
  apiUploadImage: string;
  apiDeleteImage: string;
  apiCategorySearch: string;
  apiProductSearch: string;
  apiFeaturesSearch: string;
  apiChatInit?: string;
  apiChatHistory?: string;
  apiChatSend?: string;
  apiChatConversations?: string;
  wsChatUrl?: string;
  apiAddresses?: string;
  apiAddressSetDefault?: string;
  addAddressUrl?: string;
};

const ApiConfigKey = Symbol('ApiConfig');

export function provideApiConfig(config: ApiConfig) {
  provide(ApiConfigKey, config);
}

export function useApiConfig(): ApiConfig {
  const cfg = inject<ApiConfig | undefined>(ApiConfigKey, undefined);
  if (!cfg) {
    throw new Error('ApiConfig not provided');
  }
  return cfg;
}

export async function postJson<T>(url: string, data: any, signal?: AbortSignal): Promise<T> {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data ?? {}),
    signal,
    credentials: 'include',
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`HTTP ${res.status}: ${text}`);
  }
  return res.json() as Promise<T>;
}

export async function postFormData<T>(url: string, formData: FormData, signal?: AbortSignal): Promise<T> {
  const res = await fetch(url, {
    method: 'POST',
    body: formData,
    signal,
    credentials: 'include',
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`HTTP ${res.status}: ${text}`);
  }

  try {
    return (await res.json()) as T;
  } catch {
    return undefined as unknown as T;
  }
}
